// Built-ins
import { useState } from "react";

// Icons / Images
import { FiEdit2 } from "react-icons/fi";
import { BsInfoSquare } from "react-icons/bs";

// Modules / Functions
import { Modal, Col, Form, Row } from "react-bootstrap";
import axios from "axios";
import { Button } from "semantic-ui-react";
import Swal from "sweetalert2";

// Global Variables
import { headers } from "../../../../global_vars";

window.Swal = Swal;

const CHANGE_DISTANCE =
  "https://groupplan.gr/api/data_management/change_distance_from_city_center/";

function ChangeDistanceFromCityCenter(props) {
  const [show, setShow] = useState(false);
  const [distance, setDistance] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const updateDistance = () => {
    axios({
      method: "post",
      url: CHANGE_DISTANCE,
      headers: headers,
      data: {
        object_id: props.object_id,
        object_type: props.object_type,
        distance_from_city_center: distance,
      },
    })
      .then((res) => {
        props.update_state(res.data.object);
      })
      .catch((e) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: e.response.data.errormsg,
        });
      });
  };

  const handleChange = (e) => {
    let value = e.target.value;
    if (value === "") {
      setDistance("");
      return;
    }
    value = parseFloat(value);
    if (isNaN(value) || value < 0) {
      value = 0;
    }
    setDistance(value.toString());
  };

  return (
    <>
      <FiEdit2
        title={"edit distance from city center"}
        id={"edit_hotel_distance_from_city_center"}
        onClick={() => {
          handleShow();
          setDistance(
            props.distance_from_city_center !== null &&
              props.distance_from_city_center !== undefined
              ? props.distance_from_city_center
              : ""
          );
        }}
        className={"edit_icon"}
      />
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Change distance from city center for {props.object_name}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="4">
              Distance (km):
            </Form.Label>
            <Col sm="8" style={{ marginTop: 10 }}>
              <Form.Control
                type="number"
                value={distance}
                style={{ width: 300 }}
                onChange={handleChange}
                min={0}
                step={0.1}
                placeholder="e.g. 3.2"
              />
            </Col>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <small className="mr-auto">
            <BsInfoSquare
              style={{
                color: "#F3702D",
                fontSize: "1.5em",
                marginRight: "0.5em",
              }}
            />
            Distance from city center in kilometers. Leave empty to clear.
          </small>
          <Button color="red" onClick={handleClose}>
            Close
          </Button>
          <Button
            color="green"
            onClick={() => {
              handleClose();
              updateDistance();
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ChangeDistanceFromCityCenter;
